<p-sidebar
  position="left"
  [autoZIndex]="false"
  [visible]="isVisible"
  [showCloseIcon]="false"
  [modal]="false"
  [style]="{ width: '300px' }"
  styleClass="layout-sidebar"
>
  <p-panelMenu [model]="items"></p-panelMenu>
</p-sidebar>
